/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_calendar__validate = /** @type {(inputs: {}) => string} */ () => {
	return `Bestätigen`
};

const en_calendar__validate = /** @type {(inputs: {}) => string} */ () => {
	return `Confirm`
};

const es_calendar__validate = /** @type {(inputs: {}) => string} */ () => {
	return `Confirmar`
};

const fr_calendar__validate = /** @type {(inputs: {}) => string} */ () => {
	return `Confirmer`
};

const it_calendar__validate = /** @type {(inputs: {}) => string} */ () => {
	return `Conferma`
};

const nl_calendar__validate = /** @type {(inputs: {}) => string} */ () => {
	return `Bevestigen`
};

const pt_calendar__validate = /** @type {(inputs: {}) => string} */ () => {
	return `Confirmar`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const calendar__validate = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.calendar__validate(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("calendar__validate", locale)
	if (locale === "de") return de_calendar__validate(inputs)
	if (locale === "en") return en_calendar__validate(inputs)
	if (locale === "es") return es_calendar__validate(inputs)
	if (locale === "fr") return fr_calendar__validate(inputs)
	if (locale === "it") return it_calendar__validate(inputs)
	if (locale === "nl") return nl_calendar__validate(inputs)
	return pt_calendar__validate(inputs)
};